module.exports = "/assets/dist/images/truck_wide.jpg?0749e10239f01c588d71808739515b9a";